import { render } from "./proba_redirect_button.html?vue&type=template&id=64441ce5&external"
import script from "./proba_redirect_button.js?vue&type=script&lang=js&external"
export * from "./proba_redirect_button.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__